<template>
  <div class="col-lg-3 col-md-4 col-sm-4 col-6 my-2">
    <div class="d-flex flex-column single-product-details h-100 pb-3" :style="{ borderRadius: '5px' }">
      <div class="inline_product clickable d-flex justify-content-center" :style="{
        cursor: 'pointer',
        background: '#3b71de10',
        borderRadius: '5px 5px 0px 0px',
      }">
        <div class="d-flex justify-content-end for-dicount-div-null">
          <span class="for-discoutn-value-null"></span>
        </div>
        <div v-if="item?.image_url" class="d-flex d-block" :style="{ cursor: 'pointer' }" @click="onClickView">
          <el-image :src="imgProxy(item?.image_url, rs = 'fill:250:250:1')" :alt="dt(item?.name_translations)" :style="{
            width: '100%',
            borderRadius: '5px 5px 0px 0px',
          }">
            <template #error>
              <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(item?.name_translations)"
                :style="{ width: '100%' }">
            </template>
          </el-image>
        </div>
      </div>
      <div class="position-relative" :style="{ paddingTop: '10px' }">
        <div class="text-left pl-3 text-truncate-3" :style="{ cursor: 'pointer' }" @click="onClickView">
          {{ dt(item?.name_translations) }}
          <p v-if="assorts.length == 1" class="text-black-50 text-truncate-2">{{ dt(assorts[0]?.name_translations) }}</p>
        </div>
        <div class="text-center">
          <div v-if="!hiddenPrice" class="product-price text-center">
            <div>
              <del class="text-primary">{{ priceRange(item?.price_range, "comm_price") }}</del>
            </div>
            <span class="text-accent">
              {{ priceRange(item?.price_range, "discounted_price") }}
            </span>
          </div>
          <template v-if="displayCoinReward && item?.price_range.min_owner_coin_reward > 0">
            <br>
            <span class="text-warning">
              <img src="/static/images/coin.png" :style="{ maxHeight: '30px' }" alt="coin">
              {{ priceRange(item?.price_range, "owner_coin_reward", "", true) }}
            </span>
          </template>
        </div>
      </div>

      <div class="p-2 mt-auto">
        <a v-if="isComing" :title="t('promotions.notYetStarted')" class="btn btn-dark btn-block mt-2 disabled" role="button" aria-disabled="true">
          {{ t('promotions.notYetStarted') }}
        </a>
        <el-button v-else-if="isEnded" :title="t('promotions.closed')" type="success" plain class="btn-block mt-2" disabled @click="addWishList">
          {{ t('promotions.closed') }}
        </el-button>

        <div v-else class="mt-2">
          <button title="商品詳情" class="btn btn-outline-info btn-block btn-sm" type="button" @click="onClickView">商品詳情</button>

          <template v-if="target != 'distributor' || isDistribute">
            <button v-if="assorts.length > 1" :title="t('promotions.selectSpec')" class="btn btn-secondary btn-block btn-sm" type="button" @click="showItem">
              {{ t('promotions.selectSpec') }}
            </button>

            <button v-if="!hiddenCart && assorts.length > 1" :title="aliasTranslations?.add_to_cart || t('carts.addToCart')" class="btn btn-primary btn-block btn-sm" type="button" @click="quickAddToCart">
              {{ aliasTranslations?.add_to_cart || t('carts.addToCart') }}
            </button>

            <div v-else-if="!hiddenCart && assorts.length === 1 && assorts[0].inventory > 0" class="input-group"
              :style="{ marginTop: '0.5rem' }">
              <button :title="aliasTranslations?.add_to_cart || t('carts.addToCart')" class="btn btn-primary form-control btn-sm" :class="isMobile ? 'btn-sm' : ''" type="button"
                @click="quickAddToCart">
                {{ aliasTranslations?.add_to_cart || t('carts.addToCart') }}
              </button>
            </div>

            <div v-else class="text-muted">
              <button v-if="!hiddenCart" :title="t('carts.soldOut')" class="btn btn-info btn-block btn-sm" type="button" disabled>
                {{ t('carts.soldOut') }}
              </button>
            </div>
          </template>
        </div>

        <el-button v-if="isDistribute" :title="t('coins.detail')" class="btn-block mt-2" @click="showCoinLevel">
          {{ t('coins.detail') }}
        </el-button>

        <div v-if="target == 'distributor'" class="text-center">
          <p class="text-primary font-weight-bold pt-2 mb-0">分銷商限定</p>
          <a v-if="!is_login" title="請先登入" href="/login" class="text-info" :style="{ textDecoration: 'underline' }">請先登入</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { breakpoint, dataTranslations as dt, priceRange, imgProxy, lookupAliasTranslations } from "../../utils"

const props = defineProps({
  item: Object,
  storeData: Object,
  is_login: {
    type: Boolean,
    default: false,
  },
  isDistribute: {
    type: Boolean,
    default: false,
  },
  target: String,
  isComing: {
    type: Boolean,
    default: false,
  },
  isEnded: {
    type: Boolean,
    default: false,
  },
  displayCoinReward: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['add', 'quick-add', 'show', 'show-coin', 'view'])

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs)
const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const assorts = ref([])

const getAssorts = () => {
  let tmpAssorts = [];
  // console.log("getAssorts: ", this.item.assorts);
  const qty = props.item.assorts.length == 1 ? 1 : 0
  props.item.assorts.forEach((assort) => {
    let data = {
      ...assort,
      store_assort_id: assort.id,
      store_assort_name: dt(assort.name_translations),
      store_product_id: props.item.id,
      store_product_name: dt(props.item.name_translations),
      buy_qty: qty,
    };
    tmpAssorts.push(data)
  });
  assorts.value = tmpAssorts
}

const quickAddToCart = () => {
  // console.log("quickAddToCart: ", props.item);
  emit("quick-add", props.item)
}

const showItem = () => {
  emit("show", props.item)
}

const showCoinLevel = () => {
  emit("show-coin", props.item)
}

const addWishList = () => {
  console.log("addWishList", props.item)
}

const onClickView = () => {
  // console.log("onClickView", props.item)
  emit("view", props.item)
}

watch(
  () => props.item,
  (val) => {
    if (val?.assorts && val.assorts.length) {
      getAssorts()
    }
  },
  { immediate: true }
)

</script>